module.exports = __webpack_public_path__ + "img/entrance_resume_colors_upperlayer.bbfced31.svg";